import { GROUP_LABEL_SEPARATOR } from "./select.constants";

/**
 * The selected values could be one, none, or multiple items since the component can be a single or multiple item
 * select. This function just normalises the values so they're always an array.
 * @param values Selected values.
 * @returns      Array of selected values.
 *
 * @example
 * // Returns ['a']
 * transformValues(['a']);
 *
 * @example
 * // Returns []
 * transformValues(null);
 *
 * // Returns ['a']
 * transformValues('a');
 */
export const transformValues = <IValue extends {}>(values: IValue | IValue[] | null) => {
    if (Array.isArray(values)) {
        return values;
    } else if (values === null || typeof values === "undefined") {
        return [];
    } else {
        return [values];
    }
};

/**
 * Whether an item matches a search, ignoring case. An item in a group matches on its group name too, so searching a
 * group finds all of its items.
 * @param label  The item's label.
 * @param group  The item's group name, if it has one.
 * @param search The text to look for.
 * @returns      True when the label, or the group name, contains the search.
 */
export const matchesGroupedSearch = (label: string, group: string | undefined, search: string) =>
    (group ? `${group}${GROUP_LABEL_SEPARATOR}${label}` : label).toLowerCase().includes(search.toLowerCase());
